export const reviewIdentity = rule => rule.candidate_pk || rule.id;
export const canHumanSelect = rule => rule.runtime_support !== 'hard_blocked' && (rule.selectable !== false || rule.human_selectable === true);
export const initialReviewSelection = rule => canHumanSelect(rule) && (rule.user_selected === true || rule.selected !== false);

const decisionTime = rule => {
  const value = Date.parse(rule?.decided_at || '');
  return Number.isNaN(value) ? null : value;
};

const hasNewerPersistedDecision = (localRule, serverRule) => {
  const serverTime = decisionTime(serverRule);
  const localTime = decisionTime(localRule);
  return serverTime !== null && serverRule.human_decision !== 'pending' &&
    (localTime === null || serverTime > localTime);
};

export const mergeReviewCandidates = (currentRules = [], serverRules = []) => {
  const currentByCandidatePk = new Map(
    currentRules.filter(rule => rule.candidate_pk).map(rule => [rule.candidate_pk, rule])
  );

  return serverRules.map(serverRule => {
    const hydrated = { ...serverRule, selected: initialReviewSelection(serverRule) };
    if (!serverRule.candidate_pk) return hydrated;

    const localRule = currentByCandidatePk.get(serverRule.candidate_pk);
    if (!localRule || hasNewerPersistedDecision(localRule, serverRule)) return hydrated;

    return {
      ...hydrated,
      selected: !!localRule.selected,
      ...(Object.prototype.hasOwnProperty.call(localRule, 'target_ifc_classes')
        ? { target_ifc_classes: localRule.target_ifc_classes } : {}),
      ...(Object.prototype.hasOwnProperty.call(localRule, 'review_note')
        ? { review_note: localRule.review_note } : {}),
      ...(Object.prototype.hasOwnProperty.call(localRule, 'review_status')
        ? { review_status: localRule.review_status } : {}),
    };
  });
};

export const buildReviewSubmission = (candidateRules = []) => ({
  confirmedRules: candidateRules.filter(rule => rule.selected && canHumanSelect(rule)),
  decisions: candidateRules.filter(canHumanSelect).map(rule => ({
    candidate_pk: rule.candidate_pk || undefined,
    candidate_rule_id: String(rule.id),
    decision: rule.selected ? 'confirmed' : (rule.review_status || 'not_selected'),
    note: rule.review_note || '',
  })),
});